// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"910e4fd4","453":"768ea212"}[chunkId] + ".chunk.js";
};